import { SIGNATURE_PROVIDERS } from "config/signatureProviders";
import type { SignatureProvider } from "store/agreementsStore";

export const useSignatureProvider = (providerKey?: SignatureProvider) => ({
    isDocoon: providerKey === SIGNATURE_PROVIDERS.docoon.key,
    isCrealoSign: providerKey === SIGNATURE_PROVIDERS.crealo_sign.key,
});
